import React, { useEffect } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { surveysForOrgIdSelector } from '../../reducers/survey-selectors';
import { endSurvey } from '../actions/survey/end-survey';
import { loadSurveys } from '../actions/survey/load-surveys';

import { UiButton } from '../../ui/ui-button';
import { UiDialog } from '../../ui/ui-dialog';

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  surveys: surveysForOrgIdSelector(state, orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadSurveys: () => dispatch(loadSurveys(orgId)),
    endSurvey: (surveyId: number) => dispatch(endSurvey(surveyId)),
  },
});

interface InputProps {
  surveyId: number;
  orgId: number;
  numberOfEmployeesNotSentASurvey: number;
  close: () => void;
}

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const SurveyNotSentWarningDialog = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ close, surveyId, surveys, numberOfEmployeesNotSentASurvey, actions }: Props) => {
  useEffect(() => {
    actions.loadSurveys();
  });
  if (!surveys || surveys.length === 0) {
    return null;
  }

  const handleEndSurveyClick = (surveyToEndId: number) => async () => {
    actions.endSurvey(surveyToEndId);
    close();
  };

  const otherActiveSurveys = surveys.filter(
    (s) => s.surveyId !== surveyId && moment.utc().isBetween(s.sentAt, s.endAt),
  );
  const employeesMessage = `${numberOfEmployeesNotSentASurvey} employee${
    numberOfEmployeesNotSentASurvey === 1 ? '' : 's'
  }`;

  return (
    <UiDialog title="This survey was not sent to everyone" onClose={close}>
      <UiDialog.Content>
        <div>
          Employees receive one survey at a time. When they respond or you end the survey, they
          receive the next survey in line. You have at least one survey already running, so{' '}
          <span className="typo-bold">
            {employeesMessage} will not receive this survey right away.
          </span>
        </div>
      </UiDialog.Content>
      <UiDialog.Actions>
        {otherActiveSurveys.length === 1 ? (
          <UiButton
            variant="secondary"
            onClick={handleEndSurveyClick(otherActiveSurveys[0].surveyId)}
          >
            End the Running Survey
          </UiButton>
        ) : null}
        <UiButton onClick={close}>Okay</UiButton>
      </UiDialog.Actions>
    </UiDialog>
  );
});
